import { render, staticRenderFns } from "./BlockFormSuccess.vue?vue&type=template&id=68bd32ba&scoped=true&"
import script from "./BlockFormSuccess.vue?vue&type=script&lang=ts&"
export * from "./BlockFormSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./BlockFormSuccess.vue?vue&type=style&index=0&id=68bd32ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bd32ba",
  null
  
)

export default component.exports